import React from "react";
import { connect } from "react-redux";
import moment from "moment-timezone";

class Timer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const { timezone } = props;
    this.state = { time: moment.tz(timezone) };
  }

  componentDidMount() {
    const { timezone } = this.props;
    setInterval(() => {
      this.setState({ time: moment.tz(timezone) });
    }, 1000);
  }

  render() {
    const { event } = this.props;
    const { time } = this.state;

    return (
      <div className="row" style={{ fontSize: "1.5vw" }}>
        <div className="col-xs-5" style={{ paddingTop: "15px" }}>
          {event.name}
        </div>
        <div className="col-xs-5 text-center">
          <div className="text-danger">
            <span>{time.format("dddd D, MMMM YYYY")}</span>
            <span style={{ fontSize: "2.2vw" }}>
              &nbsp; &nbsp; &nbsp;
              {time.format("hh:mm:ss A")}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  event: state.live.event,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Timer);
